module.exports = __webpack_public_path__ + "img/tv-tambem-na-vertical.39ce4e0b.png";